import React from 'react';
import './ChartTooltip.scss';

interface LegendItemProps {
  tooltipFormatterParams: any;
}

const ChartTooltip: React.FC<LegendItemProps> = ({ tooltipFormatterParams }) => {
  const marker = tooltipFormatterParams.marker;
  const value = tooltipFormatterParams.data[1] > 0 ? `${tooltipFormatterParams.data[1]}%` : '-';
  const label = tooltipFormatterParams.data[0];

  return (
    <div className="chart-tooltip">
      <div className="chart-tooltip__row">
        <div className="chart-tooltip__marker" dangerouslySetInnerHTML={{ __html: marker }} />
        <div className="chart-tooltip__text">
          <span>{label}</span>
        </div>
        <div>{value}</div>
      </div>
    </div>
  );
};

export default ChartTooltip;
